const TOKEN_KEY = 'token'
const USERNAME_KEY = 'username'
const CLUB_CODE_KEY = 'club_code'
const CLUB_NAME_KEY = 'club_name'
const PARENT_TOKEN_KEY = 'parent_token'
const PARENT_NAME_KEY = 'parent_name'
const PARENT_CHILDREN_KEY = 'parent_children'

export function isAdminLoggedIn() {
  return !!localStorage.getItem(TOKEN_KEY)
}

export function getAdminToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function getAdminUsername() {
  return localStorage.getItem(USERNAME_KEY) || ''
}

export function getClubCode() {
  return (localStorage.getItem(CLUB_CODE_KEY) || '').trim()
}

export function getClubName() {
  return localStorage.getItem(CLUB_NAME_KEY) || ''
}

export function saveClub(clubCode, clubName) {
  if (clubCode) localStorage.setItem(CLUB_CODE_KEY, clubCode)
  if (clubName != null && clubName !== undefined) localStorage.setItem(CLUB_NAME_KEY, clubName)
}

export function saveAdminLogin(token, username, clubCode, clubName) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(USERNAME_KEY, username)
  if (clubCode) saveClub(clubCode, clubName)
}

export function adminLogout() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USERNAME_KEY)
}

export function isParentLoggedIn() {
  return !!localStorage.getItem(PARENT_TOKEN_KEY)
}

export function getParentToken() {
  return localStorage.getItem(PARENT_TOKEN_KEY) || ''
}

export function getParentName() {
  return localStorage.getItem(PARENT_NAME_KEY) || ''
}

export function getParentChildren() {
  try {
    return JSON.parse(localStorage.getItem(PARENT_CHILDREN_KEY) || '[]')
  } catch (e) {
    return []
  }
}

export function saveParentLogin(token, parentName, children, clubCode, clubName) {
  localStorage.setItem(PARENT_TOKEN_KEY, token)
  localStorage.setItem(PARENT_NAME_KEY, parentName)
  localStorage.setItem(PARENT_CHILDREN_KEY, JSON.stringify(children || []))
  if (clubCode) saveClub(clubCode, clubName)
}

export function updateParentChildren(children) {
  localStorage.setItem(PARENT_CHILDREN_KEY, JSON.stringify(children || []))
}

export function parentLogout() {
  localStorage.removeItem(PARENT_TOKEN_KEY)
  localStorage.removeItem(PARENT_NAME_KEY)
  localStorage.removeItem(PARENT_CHILDREN_KEY)
}
